import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Info } from 'autogen/translation-keys/trans-website-imagealttext-icons';
import { Sponsored } from 'autogen/translation-keys/trans-website-productlists-labels';
import { InlineButtonWithIcon } from 'components/generic/InlineButton';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon';
import useSponsoredSplashQuickView from './hooks/useSponsoredSplashQuickView';

type SponsoredSplashProps = {
    productId?: number;
};

const Container = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.Spacing4};
    justify-content: flex-start;
    align-items: center;
    color: ${({ theme }) => theme.ColorTextSecondary};

`;

const Label = styled(Typography.Label)`
    color: ${({ theme }) => theme.ColorTextSecondary};
    line-height: 1em;
`;

export default function SponsoredSplash({ productId, ...restProps }: SponsoredSplashProps): JSX.Element {
    const [, toggle] = useSponsoredSplashQuickView();
    const { t } = useTranslation();

    return (
        <Container {...restProps}>
            <Label size="S">{t(Sponsored)}</Label>
            <InlineButtonWithIcon
                variant="inherit"
                type="button"
                icon={<Icon type="Information" size={16} />}
                iconProperties={{ size: '16px' }}
                onClick={() =>
                    toggle({
                        isOpen: true,
                        productId: productId
                    })
                }
                aria-label={`${t(Sponsored)} ${t(Info)}`}
            />
        </Container>
    );
}
